import * as ApiManager from './_manager';
import store from '@/store';

export const page = {
  get: (payload = null) => {
    return ApiManager.callApi (
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/page/get`,
      payload
    );
  },

  list: (payload = null) => {
    return ApiManager.callApi (
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/page/list`,
      payload
    );
  },
};
